module.exports = __webpack_public_path__ + "img/b11.2ab4cbc0.jpg";